import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';
import type { CreationContextParams } from '@atlassian/conversation-assistant-external-context/types';

export const getImageEditCommandData = (
	data: unknown,
	creationContextParams: CreationContextParams | undefined,
): unknown => {
	if (
		creationContextParams?.additionalContext?.imageEditAction !== 'removeBackground' ||
		!UNSAFE_expValNoExposure('cc_image_remove_background', 'isEnabled', false) ||
		typeof data !== 'object' ||
		data === null ||
		!('previousMediaFileId' in data) ||
		typeof data.previousMediaFileId !== 'string'
	) {
		return data;
	}

	return {
		...data,
		imageEditAction: 'removeBackground',
		...(creationContextParams.dynamicUiSource?.startLocalId
			? {
					dynamicUiSource: {
						startLocalId: creationContextParams.dynamicUiSource.startLocalId,
					},
				}
			: {}),
	};
};
